import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: 'https://631a7ac8d78841b788da0afa62932734@o962041.ingest.us.sentry.io/4508443249934336',
    integrations: [Sentry.browserTracingIntegration()],

    tracesSampleRate: 0.2,
    tracePropagationTargets: [/^https:\/\/mototechna\.cz/, /^https:\/\/mototechna\.sk/, /^https:\/\/mototechna\.pl/],
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));